export default __webpack_public_path__ + "static/pay_with_btc-dd7ea65e9a78da65475600e542ec1fd4.mp4";